<div>
  <h1>{{ translationService.getProductRecyclabilityInformation() }}</h1>
  <div [formGroup]="recyclabilityForm" class="recyclability-form-container">
    <div class="custom-form-row">
      <div class="label-with-radio-group">
        <label id="isThisARecyclableProductLabel" for="isRecyclable">{{
          translationService.getIsThisARecyclableProductText()
        }}</label>
        <mat-radio-group
          aria-labelledby="isThisARecyclableProductLabel"
          formControlName="isRecyclable"
        >
          <mat-radio-button [value]="true">{{
            translationService.getYesText()
          }}</mat-radio-button>
          <mat-radio-button [value]="false">{{
            translationService.getNoText()
          }}</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    <div class="custom-form-row">
      <div class="label-with-radio-group">
        <label id="isThisProductAPackage" for="isPackage">{{
          translationService.getIsThisProductAPackageText()
        }}</label>
        <mat-radio-group
          aria-labelledby="isThisProductAPackageLabel"
          formControlName="isPackage"
        >
          <mat-radio-button [value]="true">{{
            translationService.getYesText()
          }}</mat-radio-button>
          <mat-radio-button [value]="false">{{
            translationService.getNoText()
          }}</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    @if (recyclabilityForm.controls.isPackage.value) {
      <div class="custom-form-row">
        <div class="label-with-radio-group">
          <label id="isThisPlasticPackagingLabel" for="isPlasticPackaging">
            {{ translationService.getIsThisPlasticPackagingText() }}
          </label>
          <mat-radio-group
            aria-labelledby="isThisPlasticPackagingLabel"
            formControlName="isPlasticPackaging"
          >
            <mat-radio-button [value]="true">{{
              translationService.getYesText()
            }}</mat-radio-button>
            <mat-radio-button [value]="false">{{
              translationService.getNoText()
            }}</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    }

    <div class="custom-form-row margin-top-10">
      <mat-form-field class="input-md" appearance="outline">
        <mat-label>{{
          translationService.getRecycledContentPercentage()
        }}</mat-label>
        <input
          matInput
          name="recycledContentPercentage"
          formControlName="recycledContentPercentage"
          type="number"
          min="0"
          max="100"
        />
      </mat-form-field>
      @if (recyclabilityForm.controls.isPackage.value) {
        <mat-form-field class="input-md" appearance="outline">
          <mat-label>{{ translationService.getPackagingTypeText() }}</mat-label>
          <mat-select formControlName="packageType">
            @for (packageType of packageTypes; track packageType) {
              <mat-option [value]="packageType.name">{{
                packageType.translatedName
              }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
    </div>

    @if (recyclabilityForm.controls.isRecyclable.value) {
      <div class="custom-form-row margin-top-10">
        <p>
          {{ translationService.getSelectCountriesText() }}
        </p>
      </div>

      <div class="custom-form-row">
        <mat-form-field class="input-md" appearance="outline">
          <mat-label>{{
            translationService.getProductCountriesText()
          }}</mat-label>
          <mat-select
            [(ngModel)]="selectedCountries"
            [ngModelOptions]="{ standalone: true }"
            multiple
            (selectionChange)="onCountryChange()"
          >
            @for (country of countries; track country) {
              <mat-option [value]="country">{{ country }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      @if (canadaIsSelected) {
        <div class="provincial-recyclability-section">
          <div class="form-section-head">
            <h2>{{ translationService.getProvincialRecyclabilityText() }}</h2>
          </div>

          <div class="provincial-recyclability-message">
            <span
              >{{
                translationService.getEnterProvincialRecyclabilityInfoText()
              }}
            </span>
          </div>

          <div class="recyclability-statuses custom-form-row">
            <div class="recyclability-status">
              <img
                class="recyclability-img"
                ngSrc="assets/sustainability_highlights/recyclable.png"
                height="120"
                width="120"
                [alt]="translationService.getRecyclableText()"
              />
              <!-- Here the english and french words are shown so no need to use translationService -->
              <span>Recyclable</span>
              <span>Recyclable</span>
            </div>
            <div class="recyclability-status">
              <img
                class="recyclability-img"
                ngSrc="assets/sustainability_highlights/non_recyclable.png"
                height="120"
                width="120"
                [alt]="translationService.getNonRecyclableText()"
              />
              <!-- Here the english and french words are shown so no need to use translationService -->
              <span>Non-Recyclable</span>
              <span>Non-Recyclable</span>
            </div>
            <div class="recyclability-status">
              <img
                class="recyclability-img"
                ngSrc="assets/sustainability_highlights/collected.png"
                height="120"
                width="120"
                [alt]="translationService.getCollectedText()"
              />
              <!-- Here the english and french words are shown so no need to use translationService -->
              <span>Collected</span>
              <span>Collecté</span>
            </div>
          </div>

          <div class="custom-form-row margin-top-10">
            <mat-form-field class="input-lg" appearance="outline">
              <mat-label>{{
                translationService.getSelectProvincesAndTerritoriesText()
              }}</mat-label>
              <mat-select
                formControlName="selectedProvinces"
                multiple
                [ngClass]="{ error: isProvinceSelectionInvalid }"
              >
                @for (province of provinces; track province) {
                  <mat-option [value]="province.name">
                    {{ province.name }}
                  </mat-option>
                }
              </mat-select>

              <!-- Error message when no province is selected -->
              @if (isProvinceSelectionInvalid) {
                <mat-error>
                  {{ translationService.getAtLeastOneProvinceRequiredText() }}
                </mat-error>
              }
            </mat-form-field>
          </div>

          @for (control of provincialRecyclabilityControls; track control) {
            <div class="custom-form-row">
              <app-province-recyclability-info
                [province]="control.value.province"
                [formGroup]="control"
                [submitted]="isFormSubmitted"
              ></app-province-recyclability-info>
            </div>
            <div class="margin-top-10">
              <mat-divider></mat-divider>
            </div>
          }
        </div>
      }

      @for (control of countryRecyclabilityControls; track control) {
        @if (canadaIsSelected) {
          <mat-divider></mat-divider>
        }
        <div class="custom-form-row">
          <app-country-recyclability-info
            [country]="control.value.country"
            [formGroup]="control"
            [submitted]="isFormSubmitted"
          ></app-country-recyclability-info>
        </div>
        <div class="margin-top-10">
          <mat-divider></mat-divider>
        </div>
      }
    }
  </div>
  <div>
    <div class="actions margin-top-10">
      <button
        mat-raised-button
        extended
        color="primary"
        class="action-item"
        (click)="onSubmit()"
      >
        <mat-icon>add</mat-icon>
        {{ translationService.getNextText() }}
      </button>
      <button
        mat-raised-button
        extended
        color="primary"
        class="action-item"
        (click)="goBack()"
      >
        <mat-icon>arrow_back</mat-icon>
        {{ translationService.getBackText() }}
      </button>
      <button
        type="button"
        mat-stroked-button
        extended
        color="primary"
        class="action-item"
        (click)="reset()"
      >
        <mat-icon>refresh</mat-icon>
        {{ translationService.getResetText() }}
      </button>
    </div>
  </div>
</div>
